<template>
  <div class="sidebar-position" @click="toggle" :class="{disabled: !end}">
    <i class="fas" v-bind:class="icon" style="color:white"></i>
    <input type="checkbox" name="handleClick" class="sidebar-button" />
  </div>
</template>

<script>
import { TweenMax, Power3 } from "gsap";

export default {
  name: "Sidebar-Toggle",
  data() {
    return {};
  },
  props: {
    open: {
      type: Boolean
    },
    end: {
      type: Boolean
    },
    toggle: {
      type: Function
    }
  },
  computed: {
    icon() {
      return this.open ? "fa-chevron-right" : "fa-chevron-left";
    }
  },
  methods: {}
};
</script>

<style lang="scss">
.sidebar-position {
  position: absolute;
  z-index: 200000;
  background-color: #03b6fc;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 2px 0px 0px 2px;
  vertical-align: center;
  top: 6%;
  left: 0;
  width: 20px;
  transition: all 400ms ease-out;
  -webkit-transition: all 400ms ease-out;
  -moz-transition: all 400ms ease-out;
  -webkit-transform: translate(-1%, -50%);
  -moz-transform: translate(-1%, -50%);
  transform: translate(-103%);

  &.disabled {
    background-color: $white;

    .fas {
      color: #8f95a2 !important;
    }
  }

  .sidebar-button {
    width: 100%;
    height: 50px;
    opacity: 0;
    border: none;
    cursor: pointer;
    border-left: 1px solid #d4d4d4;
    &:checked {
      background-color: $white;
    }
  }
  .fas {
    font-size: 18px;
    cursor: pointer;
  }
  .fa-chevron-right {
    color: #8f95a2;
    position: absolute;
    bottom: 50%;
    right: 50%;
    transform: translate(50%, 50%);
  }
  .fa-chevron-left {
    color: $white;
    position: absolute;
    bottom: 50%;
    right: 50%;
    transform: translate(50%, 50%);
  }
}
</style>
